module.exports = __webpack_public_path__ + "img/nav-design-classic.0b99738.webp";